<template>
  <div class="stats">
    <div class="ui tiny progress cpu-progress" v-if="stats.cpu">
      <div class="bar" :style="stats.cpu.style"></div>
      <div class="label">
        <span class="left floated">CPU</span>
        <span class="right floated">{{stats.cpu.used}} <span v-show="instanceData">/ {{stats.cpu.total}}</span></span>
      </div>
    </div>
    <div class="ui tiny progress mem-progress" :data-tooltip="memTitle" v-if="stats.mem">
      <div class="bar" :style="stats.mem.style"></div>
      <div class="bar2" :style="stats.mem.style2"></div>
      <div class="label">
        <span class="left floated">RAM</span>
        <span class="right floated">{{stats.mem.used}} / {{stats.mem.total}}</span>
      </div>
    </div>
    <div class="ui tiny progress disk-progress" v-if="stats.disk">
      <div class="bar" :style="stats.disk.style"></div>
      <div class="label">
        <span class="left floated">{{stats.disk.type}}</span>
        <span class="right floated">{{stats.disk.used}} / {{stats.disk.total}}</span>
      </div>
    </div>
  </div>
</template>

<script>
  import utils from '@/utils'

  export default {
    name: 'Stats',
    props: {
      entity: {
        type: Object,
        required: true,
      },
    },
    computed: {
      instanceData() {
        return this.entity._instanceData || (this.entity._host && this.entity._host._instanceData) || {}
      },
      coresCorrection() {
        return this.entity.target === 'container' ? this.instanceData.cores || 1 : 1
      },
      memTitle() {
        return this.stats ? `Used: ${this.stats.mem.used}, Cached/Buffered: ${this.stats.mem.used2}` : null
      },
      stats() {
        const stats = this.entity._stats
        if (stats) {
          const {cpu, mem, disk} = stats
          const cpuPercent = typeof cpu === 'object' ? (cpu.used_percent || 0) / this.coresCorrection : null
          const memPercent = typeof mem === 'object' ? 100 * (mem.used || 0) / (mem.total || 1) : null
          const memPercent2 = typeof mem === 'object' ? 100 * ((mem.buffered || 0) + (mem.cached || 0)) / (mem.total || 1) : null
          const diskPercent = typeof disk === 'object' ? 100 * (disk.used || 0) / (disk.total || 1) : null
          return {
            cpu: {
              used: typeof cpuPercent === 'number' ? cpuPercent.toFixed(0) + '%' : '?',
              total: `${this.instanceData.cores || '?'} vCPU`,
              style: {backgroundColor: utils.getPercentColors(cpuPercent)[0], width: `${cpuPercent || 0}%`},
            },
            mem: {
              used: typeof memPercent === 'number' ? utils.prettyBytes(mem.used || 0) : '?',
              used2: typeof memPercent2 === 'number' ? utils.prettyBytes((mem.buffered || 0) + (mem.cached || 0)) : '?',
              total: typeof memPercent === 'number' && mem.total ? utils.prettyBytes(mem.total) : `${this.instanceData.memory || '?'} GB`,
              style: {width: `${memPercent}%`, backgroundColor: utils.getPercentColors(memPercent)[0]},
              style2: {width: `${memPercent2}%`, left: `${memPercent}%`, backgroundColor: utils.getPercentColors(memPercent)[1]},
            },
            disk: this.entity.target === 'host' && {
              used: diskPercent ? utils.prettyBytes(disk.used || 0) : '?',
              total: diskPercent ? utils.prettyBytes(disk.total || 0) : `${this.instanceData.storageSize || '?'} GB`,
              type: this.entity.storageType || this.instanceData.storageType || 'SSD',
              style: {backgroundColor: utils.getPercentColors(diskPercent)[0], width: `${diskPercent}%`},
            },
          }
        }
        return null
      },
    },
  }
</script>

<style scoped>
  .bar { overflow: visible!important; z-index: 1; max-width: 100%; }
  .bar2 { position: absolute; left: 100%; top: 0px; height: 100%; max-width: 100%; margin-left: -.3em; border-radius: .3em; background-color: #aaa;}
  .left.floated { float: left!important; }
  .right.floated { float: right!important; }
</style>
